module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_8019.8a00074b.png";